import type { DataProxy } from "@apollo/client";
import DiscussionCommentsByAsset from "../../../lib/graphql/queries/discussions/DiscussionCommentsByAsset";
import type { IDiscussionCommentsByAssetQuery } from "../../../lib/graphql/queries/discussions/__generated__/DiscussionCommentsByAsset.generated";

type TRootQueryData = IDiscussionCommentsByAssetQuery["discussionCommentsByAsset"];

export default function transformOnDiscussionCommentsRootQuery(
  dataProxy: DataProxy,
  assetId: string,
  transform: (rootQueryData: TRootQueryData) => TRootQueryData,
) {
  try {
    const queryData = dataProxy.readQuery<IDiscussionCommentsByAssetQuery>({
      query: DiscussionCommentsByAsset,
      variables: {
        assetId,
      },
    });

    if (!queryData) {
      return;
    }

    if (!queryData.discussionCommentsByAsset) {
      return;
    }

    dataProxy.writeQuery<IDiscussionCommentsByAssetQuery>({
      query: DiscussionCommentsByAsset,
      variables: {
        assetId,
      },
      data: {
        __typename: "Query",
        discussionCommentsByAsset: {
          ...queryData.discussionCommentsByAsset,
          ...transform(queryData.discussionCommentsByAsset),
        },
      },
    });
  } catch (err) {} // eslint-disable-line
}
